var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"maincontain"},[_c('el-container',[_c('el-header',{staticClass:"elheader"},[_c('CommonHeader')],1),_c('el-main',[_c('KeepAlive',[(_vm.$route.meta.KeepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.KeepAlive)?_c('router-view'):_vm._e()],1),_c('el-footer',[_c('CommonFooter')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }